import { ICON_COLOR, ICON_SIZE, ICON_VARIANT } from "./types";

export const iconButton = {
  [ICON_VARIANT.DEFAULT]: {
    [ICON_COLOR.DEFAULT]: {
      bg: " active:bg-fds-tertiary hover:bg-fds-secondary",
      fill: "text-fds-icon-primary disabled:text-fds-icon-disable hover:text-fds-icon-secondary",
      border: "",
    },
    [ICON_COLOR.BRAND]: {
      bg: "",
      fill: "text-fds-icon-secondary hover:text-fds-icon-brand-hover select:text-fds-icon-brand-select disabled:text-fds-icon-disable  ",
      border: "",
    },
    [ICON_COLOR.ACCENT]: {
      bg: "",
      fill: "text-fds-icon-accent hover:text-fds-icon-accent-hover select:text-fds-icon-accent-select disabled:text-fds-icon-disable  ",
      border: "",
    },
    [ICON_COLOR.DANGER]: {
      bg: "",
      fill: "text-fds-icon-danger hover:text-fds-icon-danger-hover select:text-fds-icon-danger-select disabled:text-fds-icon-disable  ",
      border: "",
    },
    [ICON_COLOR.SUCCESS]: {
      bg: "",
      fill: "text-fds-icon-success hover:text-fds-icon-success-hover select:text-fds-icon-success-select disabled:text-fds-icon-disable  ",
      border: "",
    },
    [ICON_COLOR.WARNING]: {
      bg: "",
      fill: "text-fds-icon-warning hover:text-fds-icon-warning-hover select:text-fds-icon-warning-select disabled:text-fds-icon-disable  ",
      border: "",
    },
    [ICON_COLOR.INFO]: {
      bg: "",
      fill: "text-fds-icon-info hover:text-fds-icon-info-hover select:text-fds-icon-info-select disabled:text-fds-icon-disable  ",
      border: "",
    },
  },
  [ICON_VARIANT.LIGHT]: {
    [ICON_COLOR.DEFAULT]: {
      bg: "bg-fds-secondary hover:bg-fds-secondary-hover select:bg-fds-secondary-select disabled:bg-fds-disable ",
      fill: "text-fds-icon-secondary disabled:text-fds-icon-disable",
      border: "",
    },
    [ICON_COLOR.BRAND]: {
      bg: "bg-fds-brand-light hover:bg-fds-brand-light-hover select:bg-fds-brand-light-select disable:bg-fds-disable",
      fill: "text-fds-icon-on-brand-light  hover:text-fds-icon-on-brand-light-hover select: hover:text-fds-icon-on-brand-light-select  disabled:text-fds-icon-disable  ",
      border: "",
    },
    [ICON_COLOR.ACCENT]: {
      bg: "bg-fds-accent-light hover:bg-fds-accent-light-hover select:bg-fds-accent-select disabled:bg-fds-disabled",
      fill: "text-fds-icon-on-accent-light  hover:text-fds-icon-on-accent-light-hover select:text-fds-icon-on-accent-light-select disabled:text-fds-icon-disable  ",
      border: "",
    },
    [ICON_COLOR.DANGER]: {
      bg: "bg-fds-danger-light hover:bg-fds-danger-light-hover select:bg-fds-danger-select disabled:bg-fds-disabled",
      fill: "text-fds-icon-on-danger-light  hover:text-fds-icon-on-danger-light-hover select:text-fds-icon-on-danger-light-select disabled:text-fds-icon-disable  ",
      border: "",
    },
    [ICON_COLOR.SUCCESS]: {
      bg: "bg-fds-success-light hover:bg-fds-success-light-hover select:bg-fds-success-select disabled:bg-fds-disabled",
      fill: "text-fds-icon-on-success-light  hover:text-fds-icon-on-success-light-hover select:text-fds-icon-on-success-light-select disabled:text-fds-icon-disable   ",
      border: "",
    },
    [ICON_COLOR.WARNING]: {
      bg: "bg-fds-warning-light hover:bg-fds-warning-light-hover select:bg-fds-warning-select disabled:bg-fds-disabled",
      fill: "text-fds-icon-on-warning-light  hover:text-fds-icon-on-warning-light-hover select:text-fds-icon-on-warning-light-select disabled:text-fds-icon-disable ",
      border: "",
    },
    [ICON_COLOR.INFO]: {
      bg: "bg-fds-info-light hover:bg-fds-info-light-hover select:bg-fds-info-select disabled:bg-fds-disabled",
      fill: "text-fds-icon-on-info-light  hover:text-fds-icon-on-info-light-hover select:text-fds-icon-on-info-light-select disabled:text-fds-icon-disable ",
      border: "",
    },
  },
  [ICON_VARIANT.OUTLINE]: {
    [ICON_COLOR.DEFAULT]: {
      bg: "bg-fds-primary select:bg-fds-secondary ",
      fill: "text-fds-icon-secondary disabled:text-fds-icon-disable",
      border:
        "border border-fds-default hover:border-fds-hover  select:border-fds-select disabled:border-fds-disable",
    },
    [ICON_COLOR.BRAND]: {
      bg: "bg-fds-primary bg-brand-light",
      fill: "text-fds-icon-brand  hover:text-fds-icon-brand-hover select:text-fds-icon-on-brand-light-select  disabled:text-fds-icon-disable  ",
      border:
        "border-fds-brand hover:border-fds-brand-hover select:border-fds-brand-select disabled:border-fds-disable",
    },
    [ICON_COLOR.ACCENT]: {
      bg: "bg-fds-primary bg-accent-light",
      fill: "text-fds-icon-accent  hover:text-fds-icon-accent-hover select:text-fds-icon-on-accent-light-select  disabled:text-fds-icon-disable  ",
      border:
        "border-fds-accent hover:border-fds-accent-hover select:border-fds-accent-select disabled:border-fds-disable",
    },
    [ICON_COLOR.DANGER]: {
      bg: "bg-fds-primary bg-danger-light",
      fill: "text-fds-icon-danger  hover:text-fds-icon-danger-hover select:text-fds-icon-on-danger-light-select  disabled:text-fds-icon-disable  ",
      border:
        "border-fds-danger hover:border-fds-danger-hover select:border-fds-danger-select disabled:border-fds-disable",
    },
    [ICON_COLOR.SUCCESS]: {
      bg: "bg-fds-primary bg-success-light",
      fill: "text-fds-icon-success  hover:text-fds-icon-success-hover select:text-fds-icon-on-success-light-select  disabled:text-fds-icon-disable  ",
      border:
        "border-fds-success hover:border-fds-success-hover select:border-fds-success-select disabled:border-fds-disable",
    },
    [ICON_COLOR.WARNING]: {
      bg: "bg-fds-primary bg-warning-light",
      fill: "text-fds-icon-warning  hover:text-fds-icon-warning-hover select:text-fds-icon-on-warning-light-select  disabled:text-fds-icon-disable  ",
      border:
        "border-fds-warning hover:border-fds-warning-hover select:border-fds-warning-select disabled:border-fds-disable",
    },
    [ICON_COLOR.INFO]: {
      bg: "bg-fds-primary bg-info-light",
      fill: "text-fds-icon-info  hover:text-fds-icon-info-hover select:text-fds-icon-on-info-light-select  disabled:text-fds-icon-disable  ",
      border:
        "border-fds-info hover:border-fds-info-hover select:border-fds-info-select disabled:border-fds-disable",
    },
  },
};

export const iconSize = {
  [ICON_SIZE.LARGE]: {
    size: "h-12 w-12 ",
    icon: "w-6 h-6",
    tooltip: "items-center justify-center flex",
  },
  [ICON_SIZE.MEDIUM]: {
    size: "h-10 w-10 ",
    icon: "w-5 h-5",
    tooltip: "items-center justify-center flex",
  },
  [ICON_SIZE.SMALL]: {
    size: "h-8 w-8",
    icon: "w-4 h-4",
    tooltip: "items-center justify-center flex",
  },
};
